import Vue from 'vue';
import App from './App.vue';
import createRouter from './router';
import createStore from './store';
import { sync } from 'vuex-router-sync';
import global from '@/utlis/global';

Vue.prototype.$global = global;
Vue.prototype.$server = global.server;
Vue.prototype.$ua = {};
Vue.prototype.$logEvent = () => {};

export default function createApp() {
	const router = createRouter();
	const store = createStore();
	sync(store, router);
	const app = new Vue({
		router,
		store,
		data() {
			return {
				initData: null,
			};
		},
		render: (h) => h(App),
	});
	return {
		app,
		router,
		store,
	};
}
